/**
 * Created by Mark on 20/04/2017.
 */

import Environment    from '../constants/environment.js';
import Config from '../classes/config.js';
export default class CDNAudio{
    constructor(src){
        this.src = src;
        this.cdn = Config.getAudioBaseUrl() ;
        this.audio = new Audio(this.cdn+this.src);
    }

    play(){
        this.audio.play();
    }
}


// WEBPACK FOOTER //
// ./src/classes/audio.js